<template>
    <div class="layout-container">
        <slot name="left"></slot>
        <slot name="main"></slot>
        <slot name="right"></slot>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="less">
.layout-container {
    width: 100%;
    height: 100%;
    display: flex;

    .left,
    .right {
        flex: 0 0 auto;
        overflow: hidden;
    }

    .main {
        flex: 1 1 auto;
        overflow: hidden;
    }
}
</style>